module.exports = __webpack_public_path__ + "static/btclassic-mac-screen@2x-148bea2309ad94b759a5b69b64db4079.jpg";